import { useState, useEffect } from "react";

const useFetchStats = (dataProvider, chambre, periode, legislature, type) => {
	const [stats, setStats] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const reduceStats = (stats) =>
		stats.reduce((acc, currentValue) => {
			if (!acc[currentValue["mesure"]]) {
				acc[currentValue["mesure"]] = { ...currentValue };
			}
			return acc;
		}, {});

	useEffect(() => {
		const fetchStats = async () => {
			setLoading(true);
			setError(null);
			try {
				const response = await dataProvider.getList("stats", {
					filter: {
						chambre: chambre,
						periode: periode,
						legislature: legislature,
						type: type
					},
					pagination: { perPage: 10 },
				});
				const stats = reduceStats(response.data);
				setStats(stats);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchStats();
	}, []);

	return { stats, loading, error };
};

export default useFetchStats;
